import { BaseTool } from '../BaseTool';

/** Worksets — opens the workset management dialog. */
export class WorksetsTool extends BaseTool {
    id = 'COLLAB_WORKSETS';
    name = 'Worksets';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('worksets');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
